export enum SolutionCategorization {
	Tag = "Tag",
	Industry = "Industry",
}
